// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-view{padding-bottom:3.125rem;font-size:1rem;font-family:Arial,Helvetica,\"sans-serif\"}.category-view .category-list{background:#f5f5f5;font-size:1.125rem}", ""]);
// Exports
module.exports = exports;
